<template>
  <div class="col-12">
    <table class="table table-bordered bg-white table-sm">
      <tbody>
        <tr>
          <td colspan="3">
            Usuário(s) Acompanhado(s):
            <b
              class="badge badge-light mr-2"
              v-for="pessoa in acompanhamento.pessoas_objetos"
              :key="pessoa.id"
            >
              {{
                pessoa.nome_social ? pessoa.nome_social : pessoa.nome_completo
              }}
            </b>
          </td>
        </tr>
        <tr>
          <td>
            ID:<b>{{ acompanhamento.id }}</b> Protocolo:<b>{{
              acompanhamento.protocolo
            }}</b>
          </td>
          <td>
            Criado:<b>{{ acompanhamento.cadastrado }}</b>
          </td>
          <td>
            Atualizado:<b>{{ acompanhamento.atualizado }}</b>
          </td>
        </tr>
        <tr>
          <td>
            Técnico Responsável:
            <b v-if="acompanhamento.responsavel">{{
              acompanhamento.responsavel.name
            }}</b>
            <span class="badge badge-light">
              {{
                acompanhamento.responsavel.tecnico.profissao ?? "Não informado"
              }}
            </span>
          </td>
          <td>
            Unidade:
            <b v-if="acompanhamento.unidade">{{
              acompanhamento.unidade.nome
            }}</b>
          </td>
          <td>Status: <b v-html="acompanhamento.status_nome"></b></td>
        </tr>
        <tr v-if="acompanhamento.autor">
          <td colspan="2">
            Técnico autor: <b>{{ acompanhamento.autor }}</b>
          </td>
          <td>Sigilo? <b>{{ acompanhamento.privado ? 'Sim' : 'Não' }}</b></td>
        </tr>
        <tr
          v-if="
            acompanhamento.outros_tecnicos &&
            acompanhamento.outros_tecnicos.length > 0
          "
        >
          <td colspan="3">
            Outro(s) Técnico(s):<b
              class="badge badge-light mr-2"
              v-for="(tecnico, index) in acompanhamento.outros_tecnicos"
              :key="index"
            >
              {{ tecnico.nome }}
            </b>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ["acompanhamento"],
};
</script>
